import { getUUID } from './utils'
import sortBy from 'lodash/sortBy'
let queue: Task[] = []
let currentTask: any
let suspendFlag = false
interface StatusTask {
    needComplete: boolean // 是否需要当前任务执行完成在执行下一个
    finishFlag: boolean
}

interface Task extends StatusTask {
    id: string
    priority: number // 数字越小优先级越高
    timeout?: number
    immediately?: boolean
    execContent: () => void // 执行内容
    timeoutId?: number
    expireTimestamp: number
    breakFlag: boolean
}

function exec(task: Task) {
    const { execContent, timeout, expireTimestamp, breakFlag } = task
    try {
        if (timeout) {
            let tempTimeout = timeout
            // 如果已中断的任务重新算timeout
            if (breakFlag) {
                tempTimeout = expireTimestamp - new Date().valueOf() > 0 ? expireTimestamp - new Date().valueOf() : 0
            }
            const timer: any = setTimeout(() => {
                execContent && execContent()
            }, tempTimeout)
            currentTask = { ...currentTask, timeoutId: timer }
        } else {
            execContent && execContent()
        }
    } catch (e) {
        console.error(e)
    }
}

const getNextTask = () => {
    if (!queue?.length) {
        return null
    }

    const immediatelyTask: Task[] = queue?.filter(item => item.immediately)

    if (immediatelyTask?.length) {
        const next: any = immediatelyTask.shift()

        queue = queue.filter(item => next.id !== item.id)
        // 立即执行的任务优先级比较高， 如果有延迟非紧急的任务挂起，重新放到任务队列
        if (
            !currentTask?.immediately &&
            currentTask?.timeoutId &&
            currentTask?.expireTimestamp > new Date().valueOf()
        ) {
            currentTask?.timeoutId && clearTimeout(currentTask?.timeoutId)
            queue = queue.concat({ ...currentTask, breakFlag: true })
        }
        return next
    }

    queue = sortBy(queue, o => o.priority)
    const next: any = queue.shift()

    if (
        currentTask?.timeoutId &&
        currentTask?.expireTimestamp > new Date().valueOf() &&
        next.priority < currentTask.priority
    ) {
        currentTask?.timeoutId && clearTimeout(currentTask?.timeoutId)
        queue = queue.concat({ ...currentTask, breakFlag: true })
    }
    return next
}
let timerId: any = 0
const timeout = 400
const start = () => {
    const resetTask = () => {
        if (currentTask?.needComplete) {
            if (currentTask.finishFlag) {
                currentTask = null
            }
        } else if (currentTask?.timeout) {
            if (currentTask?.expireTimestamp - new Date().valueOf() < 0) {
                currentTask = null
            }
        } else {
            currentTask = null
        }
    }
    const doTask = () => {
        function fn() {
            timerId && clearTimeout(timerId)

            if (currentTask && currentTask.needComplete && !currentTask.finishFlag) {
                timerId = setTimeout(fn, timeout)
                return
            }
            let task = getNextTask()
            if (task) {
                currentTask = task
                exec(task)
            }

            if (!task) {
                resetTask()

                if (!currentTask) {
                    suspendFlag = true
                }
            }
            if (suspendFlag) {
                return
            }
            timerId = setTimeout(fn, timeout)
        }

        timerId = setTimeout(fn, timeout)
    }
    doTask()
}
export function register(task: Task) {
    const target = { ...task, id: task.id || getUUID(), expireTimestamp: new Date().valueOf() + (task.timeout || 0) }
    queue.push(target)
    suspendFlag = false

    if (!suspendFlag) {
        start()
    }
    return {
        setFinishFlag: (finishFlag: boolean) => {
            currentTask = { ...currentTask, finishFlag }
        },
        remove: () => {
            queue = queue.filter(item => target.id !== item.id)
            if (target.id === currentTask?.id && currentTask?.timeoutId) {
                clearTimeout(currentTask?.timeoutId)
            }
        },
    }
}
